import AIChatEditorExternal from "../AIChat/AIChatEditorExternal";
const LandingDiscover = () => {
  return (
    <section className="events-page-landing-section events-page-landing-section-space events-page-landing-discover">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-landing-section-header text-center">
          <div className="events-page-landing-discover-header-label">
            Investment Research Platform
          </div>
          <h1 className="events-page-landing-section-header-heading text-center events-page-landing-discover-header-heading">
            Discover your next <br /> investment
          </h1>
          <div className="events-page-landing-section-header-text text-secondary text-center events-page-landing-discover-header-text">
            Ask intelligent questions about 50,000+ companies across 90 global
            exchanges
          </div>
        </div>

        <div className="events-page-landing-section-content">
          <AIChatEditorExternal />
        </div>
      </div>
    </section>
  );
};

export default LandingDiscover;
